import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=317c6f86&scoped=true"
import script from "./BusinessProfile.vue?vue&type=script&lang=js"
export * from "./BusinessProfile.vue?vue&type=script&lang=js"
import style0 from "./BusinessProfile.vue?vue&type=style&index=0&id=317c6f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c6f86",
  null
  
)

/* custom blocks */
import block0 from "./BusinessProfile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports